
































































































































































































































































































































































































































































































import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import ThDropdownVue from "../components/ThDropdown.vue";
import ViewAccountBookVue from "@/components/AccountBookList/ViewAccountBook.vue";
import { InvoiceStateList } from "@/data/RPA";
import ImportZipVue from "@/components/Invoice/ImportZip.vue";
import ImportTaxVue from "@/components/AccountBookList/ImportTax.vue";
import AccountingSystem from "@/data/AccountingSystem";
import { ElMessageBoxOptions } from "element-ui/types/message-box";
import ClosingVue from "./Closing.vue";
import SettingsVue from "../components/Invoice/Settings.vue";
import ThDatePickerVue from "../components/ThDatePicker.vue";
import version from "@/version";

interface MultiTab {
	id: number,
	text: string,
	button: string
}

@Component({
	components: {
		"user-tree": AllUserTreeVue,
		"month-selector": MonthSelectorVue,
		"th-dropdown": ThDropdownVue,
		"view-book": ViewAccountBookVue,
		"invoice-info": ImportZipVue,
		"import-tax": ImportTaxVue,
		"closing": ClosingVue,
		"th-date": ThDatePickerVue,
		SettingsVue
	}
})
export default class Multi extends Vue {
	query = "";
	accounterNo = "";
	tabList = [
		{
			id: 1,
			text: "税种采集",
			button: "采集"
		},
		{
			id: 2,
			text: "复制上月工资",
			button: "复制"
		},
		{
			id: 3,
			text: "一键取票",
			button: "取票"
		},
		{
			id: 4,
			text: "风险测算",
			button: "风险测算"
		},
		{
			id: 5,
			text: "登录验证",
			button: "登录验证"
		}
	];
	activeTab = this.tabList[0];

	// 下载
	down() {
		if(this.activeTab.id === 1) {
			const suffix = `&accountId=${this.$store.state.account.id}&query=${this.query}&addtax=${this.addtaxStatus.id}&accounterNo=${this.accounterNo}&page=${this.currentPage - 1}&size=${this.pageSize}`;
			this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}export/uibot/tax/info/list?taxInfoState=${this.taxInfoState.id}${suffix}&startPeriod=${this.dateValue[0]}&endPeriod=${this.dateValue[1]}&version=${version}&token=${this.$store.state.account.token}`)
		} else {
			const suffix = `&accountId=${this.$store.state.account.id}&query=${this.query}&addtax=${this.addtaxStatus.id}&accounterNo=${this.accounterNo}&invoiceState=${this.invoiceState.id}`;
			this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}export/uibot/invoice?period=${this.period}${suffix}&version=${version}&token=${this.$store.state.account.token}`)
		}

	}

	// 分页
	pageSize: number = 15;
	currentPage: number = 1;
	totalElements: number = 0;

	addtaxList: DataTable.DropItem[] = [
		{ text: "全部", id: "" },
		{ text: "小规模纳税人", id: "小规模纳税人" },
		{ text: "一般纳税人", id: "一般纳税人" },
	];
	addtaxStatus: DataTable.DropItem = this.addtaxList[0];
	riskResultList: DataTable.DropItem[] = [
		{ text: "全部", id: "" },
		{ text: "未测算", id: "0" },
		{ text: "通过", id: "1" },
		{ text: "未通过", id: "2" },
	];
	riskStatus: DataTable.DropItem = this.riskResultList[0];
	closeList: DataTable.DropItem[] = [
		{ text: "全部", id: "" },
		{ text: "未结账", id: "0" },
		{ text: "已结账", id: "1" },
	];
	closeStatus: DataTable.DropItem = this.closeList[0];
	infoStateList = [
		{ id: "", text: "全部" },
		{ id: 1, text: "未采集" },
		{ id: 2, text: "等待中" },
		{ id: 3, text: "采集中" },
		{ id: 4, text: "采集成功" },
		{ id: 5, text: "采集失败" },
	];
	taxInfoState = this.infoStateList[0];

	paySheetStateList = [
		{ id: "", text: "全部" },
		{ id: 0, text: "未产生" },
		{ id: 1, text: "已产生" },
	];
	paySheetState = this.paySheetStateList[0];

	invoiceStateList = InvoiceStateList();
	invoiceState = this.infoStateList[0];
	invoiceInfoVisbile = false;

	setVisible = false;


	verfiyStateList: DataTable.DropItem[] = [
		{ text: "全部", id: 99 },
		{ text: "未验证", id: -1 },
		{ text: "验证成功", id: 1 },
		{ text: "验证失败", id: 0 },
	];
	verfiyState = this.verfiyStateList[0];
	closeSet(isFetch: boolean) {
		this.setVisible = false;
		if (isFetch) this.fetchData();
	}

	mounted() {
		this.fetchData();
	}

	checkedBookList: AccountBookList.AccountBook[] = [];

	get checkedList() {
		const list: any[] = [];
		this.dataList.forEach(e => {
			if (e.checked) {
				list.push(e.accountBookId);
				this.checkedBookList.push(e);
			}
		});
		return list;
	}
	async operate() {
		let isAll = 0;
		if (this.checkedList.length > 0) {
			let confirmOpt: ElMessageBoxOptions = { message: `亲,是否确定进行批量 ${this.activeTab.button}` };
			if (this.activeTab.id === 3) {
				this.setVisible = true;
				return;
			}

			const action = await this.$confirm("", confirmOpt);

			if (action === "confirm") {
				let res;
				switch (this.activeTab.id) {
					case 1:
						res = await Vue.axios.post(`uibot/tax/info/save/list?accountBookId=${this.checkedList.join(",")}`, { a: 1 });
						this.$alert(res.data);
						break;
					case 2:
						this.loading = true;
						let total = this.checkedList.length;
						let count = 0;
						let times = 0;
						this.loadingMessage = `${times} / ${total}`;
						for (let i = 0; i < total; i++) {
							const res = await Vue.axios.post(`paysheetList/copy?idStrs=${this.checkedList[i]}&period=${this.period}`, { a: 1 });
							count += res.data.data;
							times++;
							this.loadingMessage = `${times} / ${total}`;
						}
						this.loading = false;
						this.$message(`批量复制上月工资：成功 ${count} 家，失败 ${total - count} 家`);
						break;
					case 3:
						res = await Vue.axios.post(`uibot/invoice/save/list?accountBookId=${this.checkedList.join(",")}&period=${this.period}&isAll=${isAll}`, { a: 1 });
						this.$alert(res.data);
						break;
				}
				this.fetchData();
			}
		} else {
			this.$alert("请选择要批量操作的账套");
		}
	}

	accounterName: string = "所属人姓名";
	// 打开tree
	isTree: boolean = false;
	openTree() {
		this.isTree = !this.isTree;
	}
	// 展开tree时,暂存tmp,以便关闭dialog时,直接从tmp展示tree
	tmp: UserTree | null = null;
	treeExpand(data: UserTree) {
		this.tmp = data;
	}
	// 点击tree中的名字(node)
	isScope: boolean = false;
	handleNodeClick(data: Account) {
		this.isScope = true;
		if (data.name) this.accounterName = data.name;
		this.currentPage = 1;
		this.$store.dispatch("clearSearchKey");
		this.accounterNo = data.no;
		this.isTree = false;
		this.fetchData();
	}

	getUrl() {
		const suffix = `&accountId=${this.$store.state.account.id}&query=${this.query}&addtax=${this.addtaxStatus.id}&accounterNo=${this.accounterNo}&page=${this.currentPage - 1}&size=${this.pageSize}`;

		let fetchUrl = `uibot/tax/info/list?taxInfoState=${this.taxInfoState.id}${suffix}`;
		switch (this.activeTab.id) {
			case 1:
				let val: string[] = [];
				if (typeof this.dateValue === "string") {
					val = [this.dateValue, this.dateValue];
				} else if (this.dateValue === undefined) {
					val = ["", ""];
				} else {
					val = this.dateValue;
				}
				fetchUrl = `uibot/tax/info/list?taxInfoState=${this.taxInfoState.id}${suffix}&startPeriod=${val[0]}&endPeriod=${val[1]}`;
				break;
			case 2:
				fetchUrl = `pay/sheet/list/copy/find?paySheetState=${this.paySheetState.id}&period=${this.period}${suffix}`;
				break;
			case 3:
				fetchUrl = `uibot/invoice/list?invoiceState=${this.invoiceState.id}&period=${this.period}${suffix}`;
				break;
			case 4:
				fetchUrl = `close/check/finddetail/list?period=${this.period}${suffix}&riskResult=${this.riskStatus.id}&closeStatus=${this.closeStatus.id}`;
				break;
			case 5:
				fetchUrl = `rpa/cookie/task/list?state=${this.verfiyState.text === "全部" ? "" : this.verfiyState.id}${suffix}`;
				break;
		}
		return fetchUrl;
	}
	changeTab(tab: MultiTab) {
		this.initPl()
		this.currentPage = 1;
		this.activeTab = tab;
		this.addtaxStatus = this.addtaxList[0];
		this.fetchData();
	}

	filterChange() {
		this.currentPage = 1;
		this.fetchData();
	}

	dataList: any[] = [];
	// 转化时间
	getTime(date: any) {
		let y = date.getFullYear();
		let m = date.getMonth() + 1;
		m = m < 10 ? "0" + m : m;
		let d = date.getDate();
		d = d < 10 ? "0" + d : d;
		let h = date.getHours();
		let minute = date.getMinutes();
		minute = minute < 10 ? "0" + minute : minute;
		return y + "-" + m + "-" + d;
	}
	async fetchData() {
		const url = this.getUrl();
		const res = await Vue.axios.get(url);
		res.data.content.forEach((v: any) => {
			v.checked = false;
			if (v.gmtModified != null) {
				if (this.activeTab.id === 5) v.gmtModified = new Date(v.gmtModified).toLocaleString("chinese", { hour12: false })
				else v.gmtModified = this.$utils.simpleDateFormat(new Date(v.gmtModified), "d")
			}
		});
		this.allChecked = false;
		this.dataList = res.data.content;
		this.totalElements = res.data.totalElements;
	}

	allChecked = false;
	checkAll() {
		if (this.activeTab.id === 4) {
			this.dataList.forEach(v => {
				if (this.command === "批量风险测算") v.checked = this.allChecked;
				else if (this.command === "批量结账") {
					if (v.closeStatus === 1) v.checked = false
					else v.checked = this.allChecked
				}
				else if (this.command === "批量反结账") {
					if (v.closeStatus === 1) v.checked = this.allChecked
					else v.checked = false
				}
			});
		}
		else if (this.activeTab.id === 3) {
			this.dataList.forEach(v => {
				if (this.command === "批量取消") {
					if (+v.invoiceState === 2 && v.taxInfoState !== 4) v.checked = this.allChecked
				} else v.checked = this.allChecked;
			});
		}
		else if (this.activeTab.id === 1) {
			this.dataList.forEach(v => {
				if (this.command === "批量采集") {
					if (v.taxInfoState !== 4) v.checked = this.allChecked;
				} else v.checked = this.allChecked;
			});
		}
		else {
			this.dataList.forEach(v => {
				if (v.taxInfoState !== 4) v.checked = this.allChecked;
			});
		}
	}
	getState(id: number) {
		for (let i = 0; i < this.verfiyStateList.length; i++) {
			const info = this.verfiyStateList[i];
			if (+info.id === +id) return info.text;
		}
	}
	renderState(id: string | number) {
		let list: { id: string | number; text: string }[] | { [x: string]: any; }[] = this.infoStateList;
		if (this.activeTab.id === 1) list = this.infoStateList;
		else if (this.activeTab.id === 3) list = this.invoiceStateList;
		for (let i = 0; i < list.length; i++) {
			const info = list[i];
			if (+info.id === +id) return info.text;
		}
		return "";
	}

	renderPaySheetState(id: number) {
		for (let i = 0; i < this.paySheetStateList.length; i++) {
			const state = this.paySheetStateList[i];
			if (state.id === id) return state.text;
		}
		return "";
	}

	handleCurrentChange(val: number) {
		this.currentPage = val;
		this.fetchData();
	}
	// 修改页数SIze
	changeSize(size: number) {
		this.pageSize = size;
		this.currentPage = 1;
		this.fetchData();
	}

	showInfo = false;
	bookData: AccountBookList.AccountBook | null = null;
	infoSuccess() {
		this.showInfo = false;
		this.fetchData();
	}
	async viewBook(data: any) {
		const res = await Vue.axios.get(`accountbooks/${data.accountBookId}`);
		this.bookData = res.data;
		this.showInfo = true;
	}
	// 一键登录
	oneKey(id: number) {
		this.$utils.oneKeyLogin(id, this, "一键登录");
	}

	async inAccountBook(data: any) {
		const res = await Vue.axios.post(`accountbooks/` + data.accountBookId);
		this.$store.dispatch("changeAccounBook", res.data);
		this.$utils.setTaxType(res.data);
		this.$utils.getRemarks();
		this.$router.push("/voucherlist");
	}

	period = "";
	changeDate(period: string) {
		this.period = period;
		this.fetchData();
	}

	// 日期筛选
	dateRange: string[] = [
	]
	dateValue = ["", ""]
	chooseDate(date: string[]) {
		// let days = new Date(2022,2,0).getDate()
		this.currentPage = 1
		this.dateValue = date
		this.$nextTick(() => {
			this.fetchData()
		});
	}

	/**
	 * 展示取票详情
	 */
	accountBookId = 0;
	showInvoiceInfo(id: number) {
		this.accountBookId = id;
		this.invoiceInfoVisbile = true;
	}
	closeInvoiceInfo() {
		this.invoiceInfoVisbile = false;
		this.fetchData();
	}

	/**
	 * 税种采集详情
	 */
	taxInfoVisible = false;
	showTaxInfo(id: number) {
		this.accountBookId = id;
		this.taxInfoVisible = true;
	}

	// 批量取消
	async cancellation() {
		if (this.checkedList.length > 0) {
			const action = await this.$confirm(`亲,是否确定进行 批量取消`);
			if (action === "confirm") {
				const res = await Vue.axios.post(`uibot/invoice/delete/list?accountBookId=${this.checkedList.join(",")}&period=${this.period}`, { a: 1 });
				this.$notify({
					message: res.data,
					title: "取消完成"
				});
				this.fetchData();

			}
		} else {
			this.$alert("请选择要批量操作的账套");
		}
	}
	messages: string = ""
	showMessage: boolean = false
	async invoiceMultiImport() {
		if (this.checkedList.length > 0) {
			const action = await this.$confirm(`亲,是否确定进行 批量导入`);
			if (action === "confirm") {
				this.messages = "";
				this.loading = true;
				for (let i = 0; i < this.checkedList.length; i++) {
					// const book = this.checkedList[i];
					console.log(this.checkedList[i])
					const res = await Vue.axios.post(`uibot/invoice/import/list?accountBookId=${this.checkedList[i]}&period=${this.period}`, { a: 1 }, { headers: { accountBookId: this.checkedList[i] } });
					if (res.data.message) this.messages += res.data.message + "\n";
				}
				this.loading = false;
				this.showMessage = true;
				await this.fetchData();
			}
		} else {
			this.$alert("请选择要批量操作的账套");
		}
	}

	async oneKeyLogin(id: number) {
		this.$utils.oneKeyLogin(id, this, "勾选认证");
	}

	getRisk(id: number) {
		if (id === 0) return "未测算";
		else if (id === 1) return "通过";
		else if (id === 2) return "未通过";
	}
	getClose(id: number) {
		if (id === 0) return "未结账";
		else if (id === 1) return "已结账";
	}
	loading = false;
	loadingMessage = "";

	async confirmFn(confirmText: string, api: string, id?: number | string) {
		let ids: string[] | number[] = [];
		if (id) ids = [id.toString()];
		else ids = this.checkedList;
		const action = await this.$confirm(
			`亲，确定要批量${confirmText}吗？`,
			"温馨提示"
		);
		if (action === "confirm") {
			this.loading = true;
			let total = ids.length;
			let count = 0;
			let times = 0;
			this.loadingMessage = `${times} / ${total}`;
			for (let i = 0; i < total; i++) {
				const res = await Vue.axios.post(`${api}?ids=${ids[i]}&endPeriod=${this.period}`, { a: 1 });
				count += res.data.data;
				times++;
				this.loadingMessage = `${times} / ${total}`;
			}

			this.loading = false;
			this.$message(`批量${confirmText}：通过 ${count} 家，未通过 ${total - count} 家`);
			this.initPl();
			this.fetchData();
		}
	}

	// 风险测算
	async risk(id?: number | string) {
		await this.confirmFn("风险测算", "close/check/finddetail/multi", id);
	}
	// 结账
	async closingAccount(id?: number | string) {
		await this.confirmFn("结账", "close/accountbook/multi", id);
	}
	async overCheck(id?: number | string) {
		await this.confirmFn("反结账", "close/accountbook/reverse/multi", id);
	}
	showCheck = false;
	command = "";
	changeMore(command: string) {
		this.showCheck = true;
		this.isPL = true;
		this.command = command;
	}
	getDisabled(data: any) {
		if (this.command === "批量风险测算") return false;
		else if (this.command === "批量结账") {
			if (data.closeStatus === 1) return true;
			else return false
		}
		else if (this.command === "批量反结账") {
			if (data.closeStatus === 1) return false
			else return true;
		} else if (this.command === "批量取消") {
			if (+data.invoiceState === 2) return false
			else return true
		}
		else if (this.command === "批量采集") {
			if (+data.taxInfoState === 4) return true
			else return false
		}
	}
	isPL: boolean = false;
	plBtn: string = "取消";
	initPl() {
		this.showCheck = false;
		this.isPL = false;
		this.plBtn = "取消";
	}
	plClick() {
		if (this.plBtn === "取消") {
			this.isPL = false;
			this.showCheck = false;
		}
		if (this.plBtn === "批量风险测算") {
			this.risk();
		}
		if (this.plBtn === "批量结账") {
			this.closingAccount();
		}
		if (this.plBtn === "批量反结账") {
			this.overCheck();
		}
		if (this.plBtn === "批量导入") {
			this.invoiceMultiImport();
		}
		if (this.plBtn === "批量取票") {
			this.operate();
		}
		if (this.plBtn === "批量取消") {
			this.cancellation();
		} 
		if(this.plBtn === "批量采集") {
			this.operate()
		}
		if(this.plBtn === "批量设置") {
			this.isSet = true
		}
	}
	async saveTaxInfo(){
		let list = this.taxData
		list.startDate = list.startDate !=""?this.$utils.simpleDateFormat(new Date(<Date>list.startDate),"d",true):""
		list.endDate = list.endDate !=""?this.$utils.simpleDateFormat(new Date(<Date>list.endDate),"d",true):""
		list.accountBookIdStr = this.checkedList.join(",")
	   	if(list.endDate !="" && list.startDate !=""  && list.taxInfoType !="") {
			const res = await Vue.axios.post(`uibot/tax/info/set/list`,this.taxData);
			if(res) {
				this.$message(res.data);
			}
			this.isSet = false
			this.isPL = false
			this.fetchData()

		} else {
			this.$message.warning("请填写完整内容");
		}	



	}
	isTaxList:any = [
		{
			id:1,
			text:"是"
		},
		{
			id:0,
			text:"否"
		},
	]
	taxType: string[] = [
	"增值税",
	"城市维护建设税",
	"教育费附加",
	"地方教育附加",
	"企业所得税",
	"印花税",
    "其他收入",
    "残疾人就业保障金",
    "文化事业建设费",
    "消费税",
    "水利建设专项收入",
    "个人所得税",
    "房产税",
    "行政性收费收入",
    "社保",
     "其他专项收入",
     "财务报表",
	 "城镇土地使用税"
	]
	taxInfoMethod = [
		{
			id:0,
			text:"季"
		},
		{
			id:1,
			text:"月"
		},
		{
			id:2,
			text:"次"
		},
		{
			id:3,
			text:"半年"
		},
		{
			id:4,
			text:"年"
		},
	]
	taxData:any = {
		code: null,
		endDate: "",
		gmtCreate: null,
		gmtModified: null,
		id: null,
		isTaxInfo: 1,
		source: 2,
		startDate: "",
		taxInfoDetail: "",
		taxInfoMethod: 0,
		taxInfoType: "",
		taxRate: "",
		accountBookIdStr:"",
	}
	isSet: boolean = false
	closeVisible = false;
	closeData: any = {};
	async clickClose(id: number) {
		const res = await Vue.axios.get(`risk/find?id=${id}`);
		if (res) {
			this.closeData = res.data.data;
			this.closeVisible = true;
		}
	}
	@Watch("dataList", { deep: true })
	listChange(val: any[]) {
		if (this.activeTab.id === 4 || this.activeTab.id === 3 || this.activeTab.id === 1) {
			let all = true;
			let hasSelect = false;
			for (let i = 0; i < val.length; i++) {
				if (val[i].checked) {
					hasSelect = true;
				}
			}
			if (hasSelect) this.plBtn = this.command;
			else this.plBtn = "取消";
			for (let i = 0; i < val.length; i++) {
				if (!val[i].checked) {
					all = false;
					break;
				}
			}
			if (val.length === 0) all = false;
			this.allChecked = all;
		}
	}

	// 复制链接
	isJzs = process.env.VUE_APP_TITLE === "jzs";
	copyUrl(data: any) {
		let url = `https://auth.jinzhangshi.com/#/?accountBookId=${data.accountBookId}&isEnv=${this.isJzs ? "jzs" : "blob"}`
		// @ts-ignore
		navigator.clipboard.writeText(url + " 邀请您进行电子税务局新版登录信息验证").then(() => {
			this.$message({
				type: "success",
				message: "复制成功",
			});
		})
	}
	generateQRCode(data: any, index: number) {
		let url = `https://auth.jinzhangshi.com/#/?accountBookId=${data.accountBookId}&isEnv=${this.isJzs ? "jzs" : "blob"}`
		// @ts-ignore
		const canvas = new QRious({
			element: document.querySelector(".qrCodeCanvas" + index),
			value: url,
			size: 150
		})
		const aa = (<any>document.querySelector(".qrCodeCanvas" + index)!);
		aa.toBlob((blob: any) => {
			// 使用 Clipboard API 将 Blob 对象写入剪贴板
			// @ts-ignore
			navigator.clipboard.write([new ClipboardItem({ "image/png": blob })])
				.then((msg: any) => {
					this.$message({
						type: "success",
						message: "二维码复制成功",
					});
				})
				.catch((error: any) => {
					this.$message("二维码复制失败")
				});
		}, "image/png");
	}
	isDisabled(data: any) {
		if (data.taxPayerPhone === null || !data.taxPayerPhone || data.state === 1) return true
		else return false
	}
}
